/**
 * Convert SVG to PNG data URL using Canvas API
 * This allows SVGs to be used in PDFs via @react-pdf/renderer
 */
export const svgToPng = async (svgUrl: string, width = 200, height = 200): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Handle CORS if needed

    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Could not get canvas context'));
          return;
        }

        // Draw with white background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);

        // Draw the image
        ctx.drawImage(img, 0, 0, width, height);

        // Convert to PNG data URL
        const pngDataUrl = canvas.toDataURL('image/png');
        resolve(pngDataUrl);
      } catch (error) {
        reject(error);
      }
    };

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${svgUrl}`));
    };

    img.src = svgUrl;
  });
};

/**
 * Check if a URL points to an SVG file
 */
export const isSvgUrl = (url: string): boolean => {
  return url.toLowerCase().endsWith('.svg') || url.includes('data:image/svg+xml');
};
